const supportedRegionIdentifiers = [
  "AE",
  "AR",
  "AT",
  "AU",
  "BE",
  "BH",
  "BO",
  "BR",
  "CA",
  "CH",
  "CL",
  "CO",
  "CR",
  "DE",
  "DK",
  "DO",
  "EC",
  "EG",
  "ES",
  "FI",
  "FR",
  "GB",
  "GH",
  "GT",
  "HN",
  "IE",
  "IL",
  "IT",
  "JO",
  "JP",
  "KE",
  "KR",
  "KW",
  "LB",
  "LU",
  "MA",
  "MX",
  "NI",
  "NL",
  "NO",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PH",
  "PK",
  "PL",
  "PT",
  "PY",
  "QA",
  "SA",
  "SE",
  "SG",
  "SV",
  "US",
  "UY",
  "VE",
  "ZA"
];
const supportedLanguageGroupIdentifiers = ["de", "en", "es", "fr", "ja", "ko"];
const supportedLocaleIdentifiers = [
  "de-DE",
  "en-AU",
  "en-BR",
  "en-CA",
  "en-GB",
  "en-US",
  "en-150",
  "en-145",
  "en-035",
  "es-419",
  "es-ES",
  "es-MX",
  "es-US",
  "fr-CA",
  "fr-FR",
  "ja-JP",
  "ko-KR"
];
const defaultLocale = "en-US";
const flagSrcMap = {
  US: "https://cdn.shopify.com/s/files/1/0139/8942/files/flag-us-icon.png?v=1607119686",
  CA: "https://cdn.shopify.com/s/files/1/0139/8942/files/flag-ca-icon.png?v=1607119998",
  AU: "https://cdn.shopify.com/s/files/1/0139/8942/files/flag-au-icon.png?v=1607120288",
  default: "https://cdn.shopify.com/s/files/1/0139/8942/files/flag-globe-icon.png?v=1607119990"
};
const argentina = {
  id: "AR",
  isEnabled: true,
  name: "Argentina",
  currency: "ARS",
  defaultLocale: "es-419",
  languages: {
    es: {
      locale: "es-419",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const australia = {
  id: "AU",
  isEnabled: true,
  name: "Australia",
  currency: "AUD",
  defaultLocale: "en-AU",
  languages: {
    en: {
      locale: "en-AU",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.AU
};
const austria = {
  id: "AT",
  isEnabled: true,
  name: "Austria",
  currency: "EUR",
  defaultLocale: "en-150",
  languages: {
    en: {
      locale: "en-150",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const belgium = {
  id: "BE",
  isEnabled: true,
  name: "Belgium",
  currency: "EUR",
  defaultLocale: "en-150",
  languages: {
    en: {
      locale: "en-150",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const bolivia = {
  id: "BO",
  isEnabled: true,
  name: "Bolivia",
  currency: "BOB",
  defaultLocale: "es-419",
  languages: {
    es: {
      locale: "es-419",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const brazil = {
  id: "BR",
  isEnabled: true,
  name: "Brazil",
  currency: "BRL",
  defaultLocale: "en-BR",
  languages: { en: { locale: "en-BR", isEnabled: true } },
  flagSrc: flagSrcMap.default
};
const canada = {
  id: "CA",
  isEnabled: true,
  name: "Canada",
  currency: "CAD",
  defaultLocale: "en-CA",
  languages: {
    en: {
      locale: "en-CA",
      isEnabled: true
    },
    fr: {
      locale: "fr-CA",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.CA
};
const chile = {
  id: "CL",
  isEnabled: true,
  name: "Chile",
  currency: "CLP",
  defaultLocale: "es-419",
  languages: {
    es: {
      locale: "es-419",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const colombia = {
  id: "CO",
  isEnabled: true,
  name: "Colombia",
  currency: "COP",
  defaultLocale: "es-419",
  languages: {
    es: {
      locale: "es-419",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const costaRica = {
  id: "CR",
  isEnabled: true,
  name: "Costa Rica",
  currency: "CRC",
  defaultLocale: "es-419",
  languages: {
    es: {
      locale: "es-419",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const denmark = {
  id: "DK",
  isEnabled: true,
  name: "Denmark",
  currency: "DKK",
  defaultLocale: "en-150",
  languages: { en: { locale: "en-150", isEnabled: true } },
  flagSrc: flagSrcMap.default
};
const dominicanRepublic = {
  id: "DO",
  isEnabled: true,
  name: "Dominican Republic",
  currency: "DOP",
  defaultLocale: "es-419",
  languages: {
    es: {
      locale: "es-419",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const ecuador = {
  id: "EC",
  isEnabled: true,
  name: "Ecuador",
  currency: "USD",
  defaultLocale: "es-419",
  languages: {
    es: {
      locale: "es-419",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const elSalvador = {
  id: "SV",
  isEnabled: true,
  name: "El Salvador",
  currency: "USD",
  defaultLocale: "es-419",
  languages: {
    es: {
      locale: "es-419",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const finland = {
  id: "FI",
  isEnabled: true,
  name: "Finland",
  currency: "EUR",
  defaultLocale: "en-150",
  languages: {
    en: {
      locale: "en-150",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const france = {
  id: "FR",
  isEnabled: true,
  name: "France",
  currency: "EUR",
  defaultLocale: "fr-FR",
  languages: {
    en: {
      locale: "en-150",
      isEnabled: true
    },
    fr: {
      locale: "fr-FR",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const germany = {
  id: "DE",
  isEnabled: true,
  name: "Germany",
  currency: "EUR",
  defaultLocale: "de-DE",
  languages: {
    en: {
      locale: "en-150",
      isEnabled: true
    },
    de: {
      locale: "de-DE",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const guatemala = {
  id: "GT",
  isEnabled: true,
  name: "Guatemala",
  currency: "GTQ",
  defaultLocale: "es-419",
  languages: {
    es: {
      locale: "es-419",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const honduras = {
  id: "HN",
  isEnabled: true,
  name: "Honduras",
  currency: "HNL",
  defaultLocale: "es-419",
  languages: {
    es: {
      locale: "es-419",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const ireland = {
  id: "IE",
  isEnabled: true,
  name: "Ireland (Republic of)",
  currency: "EUR",
  defaultLocale: "en-150",
  languages: {
    en: {
      locale: "en-150",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const israel = {
  id: "IL",
  isEnabled: true,
  name: "Israel",
  currency: "ILS",
  defaultLocale: "en-145",
  languages: {
    en: {
      locale: "en-145",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const italy = {
  id: "IT",
  isEnabled: true,
  name: "Italy",
  currency: "EUR",
  defaultLocale: "en-150",
  languages: {
    en: {
      locale: "en-150",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const japan = {
  id: "JP",
  isEnabled: true,
  name: "Japan",
  currency: "JPY",
  defaultLocale: "ja-JP",
  languages: {
    ja: {
      locale: "ja-JP",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const kuwait = {
  id: "KW",
  isEnabled: true,
  name: "Kuwait",
  currency: "USD",
  defaultLocale: "en-145",
  languages: {
    en: {
      locale: "en-145",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const luxembourg = {
  id: "LU",
  isEnabled: true,
  name: "Luxembourg",
  currency: "EUR",
  defaultLocale: "en-150",
  languages: {
    en: {
      locale: "en-150",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const mexico = {
  id: "MX",
  isEnabled: true,
  name: "Mexico",
  currency: "MXN",
  defaultLocale: "es-MX",
  languages: {
    es: {
      locale: "es-MX",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const netherlands = {
  id: "NL",
  isEnabled: true,
  name: "Netherlands",
  currency: "EUR",
  defaultLocale: "en-150",
  languages: {
    en: {
      locale: "en-150",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const newZealand = {
  id: "NZ",
  isEnabled: true,
  name: "New Zealand",
  currency: "NZD",
  defaultLocale: "en-AU",
  languages: {
    en: {
      locale: "en-AU",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const nicaragua = {
  id: "NI",
  isEnabled: true,
  name: "Nicaragua",
  currency: "NIO",
  defaultLocale: "es-419",
  languages: {
    es: {
      locale: "es-419",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const norway = {
  id: "NO",
  isEnabled: true,
  name: "Norway",
  currency: "NOK",
  defaultLocale: "en-150",
  languages: { en: { locale: "en-150", isEnabled: true } },
  flagSrc: flagSrcMap.default
};
const panama = {
  id: "PA",
  isEnabled: true,
  name: "Panama",
  currency: "USD",
  defaultLocale: "es-419",
  languages: {
    es: {
      locale: "es-419",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const paraguay = {
  id: "PY",
  isEnabled: true,
  name: "Paraguay",
  currency: "PYG",
  defaultLocale: "es-419",
  languages: {
    es: {
      locale: "es-419",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const peru = {
  id: "PE",
  isEnabled: true,
  name: "Peru",
  currency: "PEN",
  defaultLocale: "es-419",
  languages: {
    es: {
      locale: "es-419",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const philippines = {
  id: "PH",
  isEnabled: true,
  name: "Philippines",
  currency: "PHP",
  defaultLocale: "en-035",
  languages: {
    en: {
      locale: "en-035",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const poland = {
  id: "PL",
  isEnabled: true,
  name: "Poland",
  currency: "PLN",
  defaultLocale: "en-150",
  languages: {
    en: {
      locale: "en-150",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const portugal = {
  id: "PT",
  isEnabled: true,
  name: "Portugal",
  currency: "EUR",
  defaultLocale: "en-150",
  languages: {
    en: {
      locale: "en-150",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const saudiArabia = {
  id: "SA",
  isEnabled: true,
  name: "Saudi Arabia",
  currency: "SAR",
  defaultLocale: "en-145",
  languages: {
    en: {
      locale: "en-145",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const singapore = {
  id: "SG",
  isEnabled: true,
  name: "Singapore",
  currency: "SGD",
  defaultLocale: "en-035",
  languages: {
    en: {
      locale: "en-035",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const southKorea = {
  id: "KR",
  isEnabled: true,
  name: "South Korea",
  currency: "KRW",
  defaultLocale: "ko-KR",
  languages: {
    ko: {
      locale: "ko-KR",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const spain = {
  id: "ES",
  isEnabled: true,
  name: "Spain",
  currency: "EUR",
  defaultLocale: "es-ES",
  languages: {
    en: {
      locale: "en-150",
      isEnabled: true
    },
    es: {
      locale: "es-ES",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const sweden = {
  id: "SE",
  isEnabled: true,
  name: "Sweden",
  currency: "SEK",
  defaultLocale: "en-150",
  languages: { en: { locale: "en-150", isEnabled: true } },
  flagSrc: flagSrcMap.default
};
const switzerland = {
  id: "CH",
  isEnabled: true,
  name: "Switzerland",
  currency: "CHF",
  defaultLocale: "en-150",
  languages: { en: { locale: "en-150", isEnabled: true } },
  flagSrc: flagSrcMap.default
};
const uae = {
  id: "AE",
  isEnabled: true,
  name: "United Arab Emirates",
  currency: "AED",
  defaultLocale: "en-145",
  languages: {
    en: {
      locale: "en-145",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const unitedKingdom = {
  id: "GB",
  isEnabled: true,
  name: "United Kingdom",
  currency: "GBP",
  defaultLocale: "en-GB",
  languages: {
    en: {
      locale: "en-GB",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const unitedStates = {
  id: "US",
  isEnabled: true,
  name: "United States",
  currency: "USD",
  defaultLocale: "en-US",
  languages: {
    en: {
      locale: "en-US",
      isEnabled: true
    },
    es: {
      locale: "es-US",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.US
};
const uruguay = {
  id: "UY",
  isEnabled: true,
  name: "Uruguay",
  currency: "UYU",
  defaultLocale: "es-419",
  languages: {
    es: {
      locale: "es-419",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const venezuela = {
  id: "VE",
  isEnabled: true,
  name: "Venezuela",
  currency: "USD",
  defaultLocale: "es-419",
  languages: {
    es: {
      locale: "es-419",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const bahrain = {
  id: "BH",
  isEnabled: true,
  name: "Bahrain",
  currency: "USD",
  defaultLocale: "en-145",
  languages: {
    en: {
      locale: "en-145",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const egypt = {
  id: "EG",
  isEnabled: true,
  name: "Egypt",
  currency: "EGP",
  defaultLocale: "en-145",
  languages: {
    en: {
      locale: "en-145",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const jordan = {
  id: "JO",
  isEnabled: true,
  name: "Jordan",
  currency: "USD",
  defaultLocale: "en-145",
  languages: {
    en: {
      locale: "en-145",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const lebanon = {
  id: "LB",
  isEnabled: true,
  name: "Lebanon",
  currency: "USD",
  defaultLocale: "en-145",
  languages: {
    en: {
      locale: "en-145",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const kenya = {
  id: "KE",
  isEnabled: true,
  name: "Kenya",
  currency: "KES",
  defaultLocale: "en-145",
  languages: {
    en: {
      locale: "en-145",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const morocco = {
  id: "MA",
  isEnabled: true,
  name: "Morocco",
  currency: "MAD",
  defaultLocale: "en-145",
  languages: {
    en: {
      locale: "en-145",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const oman = {
  id: "OM",
  isEnabled: true,
  name: "Oman",
  currency: "USD",
  defaultLocale: "en-145",
  languages: {
    en: {
      locale: "en-145",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const qatar = {
  id: "QA",
  isEnabled: true,
  name: "Qatar",
  currency: "QAR",
  defaultLocale: "en-145",
  languages: {
    en: {
      locale: "en-145",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const southAfrica = {
  id: "ZA",
  isEnabled: true,
  name: "South Africa",
  currency: "ZAR",
  defaultLocale: "en-145",
  languages: {
    en: {
      locale: "en-145",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const pakistan = {
  id: "PK",
  isEnabled: true,
  name: "Pakistan",
  currency: "PKR",
  defaultLocale: "en-145",
  languages: {
    en: {
      locale: "en-145",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const ghana = {
  id: "GH",
  isEnabled: true,
  name: "Ghana",
  currency: "USD",
  defaultLocale: "en-145",
  languages: {
    en: {
      locale: "en-145",
      isEnabled: true
    }
  },
  flagSrc: flagSrcMap.default
};
const supportedRegions = {
  AE: uae,
  AR: argentina,
  AT: austria,
  AU: australia,
  BE: belgium,
  BO: bolivia,
  BR: brazil,
  CA: canada,
  CH: switzerland,
  CL: chile,
  CO: colombia,
  CR: costaRica,
  DE: germany,
  DK: denmark,
  DO: dominicanRepublic,
  EC: ecuador,
  ES: spain,
  FI: finland,
  FR: france,
  GB: unitedKingdom,
  GT: guatemala,
  HN: honduras,
  IE: ireland,
  IL: israel,
  IT: italy,
  JP: japan,
  KR: southKorea,
  KW: kuwait,
  LU: luxembourg,
  MX: mexico,
  NI: nicaragua,
  NL: netherlands,
  NO: norway,
  NZ: newZealand,
  PA: panama,
  PE: peru,
  PH: philippines,
  PL: poland,
  PT: portugal,
  PY: paraguay,
  SA: saudiArabia,
  SE: sweden,
  SG: singapore,
  SV: elSalvador,
  US: unitedStates,
  UY: uruguay,
  VE: venezuela,
  BH: bahrain,
  EG: egypt,
  GH: ghana,
  JO: jordan,
  KE: kenya,
  LB: lebanon,
  MA: morocco,
  OM: oman,
  PK: pakistan,
  QA: qatar,
  ZA: southAfrica
};

function isValidLocale(locale) {
  const supportedLocaleIdentifiersAsStrings = supportedLocaleIdentifiers;
  return supportedLocaleIdentifiersAsStrings.indexOf(locale) > -1;
}
function isValidCountryCode(countryCode) {
  if (typeof countryCode !== "string")
    return false;
  const supportedRegionIdentifiersAsStrings = supportedRegionIdentifiers;
  return supportedRegionIdentifiersAsStrings.indexOf(countryCode) > -1;
}
function isValidLanguageGroup(language) {
  const supportedLanguageGroupIdentifiersAsStrings = supportedLanguageGroupIdentifiers;
  return supportedLanguageGroupIdentifiersAsStrings.indexOf(language) > -1;
}
function filterRegion(region, options) {
  if (options?.countryCode && region.id !== options.countryCode) {
    return false;
  }
  if (options?.isEnabled !== void 0 && region.isEnabled !== options.isEnabled) {
    return false;
  }
  return true;
}
function retrieveRegion(options) {
  const matches = retrieveRegions(options);
  const firstMatch = matches.length === 1 ? matches[0] : null;
  if (!firstMatch && options?.defaultFallback !== true) {
    return null;
  }
  return firstMatch ? firstMatch : supportedRegions.US;
}
function retrieveRegions(options) {
  const matches = Object.entries(supportedRegions).filter(([key, region]) => {
    if (key === "default") {
      return false;
    }
    return filterRegion(region, options);
  }).map(([_key, region]) => {
    return region;
  });
  return matches;
}
function retrieveLocale(options) {
  let result = null;
  let region = null;
  if (typeof options?.region === "string") {
    region = retrieveRegion({
      countryCode: options.region,
      defaultFallback: false
    });
  } else if (options?.region) {
    region = options.region;
  }
  const fallbackResult = region ? region.defaultLocale : defaultLocale;
  const validResults = region ? retrieveLocalesForRegion(region, {
    language: options?.language
  }) : supportedLocaleIdentifiers;
  if (options?.language && region && isValidLanguageGroup(options?.language)) {
    const regionalLanguage = region.languages[options.language] ?? null;
    result = regionalLanguage ? regionalLanguage.locale : result;
  }
  if (options?.locale) {
    if (result && result !== options.locale) {
      result = null;
    } else if (isValidLocale(options.locale)) {
      result = validResults.includes(options.locale) ? options.locale : result;
    }
  }
  if (!result && options?.defaultFallback !== true) {
    return null;
  }
  return result ?? fallbackResult;
}
function retrieveLanguage(options) {
  const match = Object.entries(options.region.languages).find(
    ([_languageIdentifier, languageMetadata]) => {
      return options.isEnabled && !languageMetadata.isEnabled ? false : options.locale === languageMetadata.locale;
    }
  )?.[0];
  const defaultLanguage = Object.entries(options.region.languages)[0][0];
  if (!match && options.defaultFallback !== true) {
    return null;
  }
  return match ?? defaultLanguage;
}
function retrieveLocalesForRegion(region, options) {
  const results = Object.entries(region.languages).reduce(
    (results2, [key, language]) => {
      if (options?.isEnabled !== void 0 && language.isEnabled !== options.isEnabled) {
        return results2;
      }
      if (options?.language && key !== options.language) {
        return results2;
      }
      results2.push(language.locale);
      return results2;
    },
    []
  );
  return results;
}
function retrieveLanguageGroupsForRegion(region, options) {
  const results = Object.entries(region.languages).reduce(
    (results2, [key, language]) => {
      if (options?.isEnabled !== void 0 && language.isEnabled !== options.isEnabled) {
        return results2;
      }
      if (options?.locale !== void 0 && language.locale !== options.locale) {
        return results2;
      }
      results2.push(key);
      return results2;
    },
    []
  );
  return results;
}
function retrieveEnabledLocales(region) {
  const results = Object.entries(region.languages).reduce(
    (results2, [_, language]) => {
      if (language.isEnabled) {
        results2.push(language.locale);
      }
      return results2;
    },
    []
  );
  return results;
}
function retrieveLanguageRegionPairs() {
  const lr = [];
  Object.entries(supportedRegions).forEach(([key, region]) => {
    if (key !== "default") {
      Object.entries(region.languages).forEach(([langKey, value]) => {
        if (value.isEnabled) {
          lr.push(`${langKey}-${region.id}`);
        }
      });
    }
  });
  return lr;
}

export { defaultLocale, flagSrcMap, isValidCountryCode, isValidLanguageGroup, isValidLocale, retrieveEnabledLocales, retrieveLanguage, retrieveLanguageGroupsForRegion, retrieveLanguageRegionPairs, retrieveLocale, retrieveLocalesForRegion, retrieveRegion, retrieveRegions, supportedLanguageGroupIdentifiers, supportedLocaleIdentifiers, supportedRegionIdentifiers, supportedRegions };
